import { useState } from 'react';
import { BadgePresentation } from './presentation';

type BaseProps = {
  /** ステータス */
  status: 'neutral' | 'info' | 'success' | 'warning' | 'negative';
  /** バリエーション */
  variant: 'outline' | 'solid' | 'subtle';
  /** ラベルのテキスト */
  label: string;
};

// size: 'sm' の場合はcloseボタンを表示しない
type SmallBadgeProps = BaseProps & {
  size: 'sm';
  showClose?: never;
  onClose?: never;
};

// showClose: falseの場合はonCloseを渡せない
type MediumLargeBadgeProps = BaseProps & {
  size: 'md' | 'lg';
} & ({ showClose: true; onClose: () => void } | { showClose: false; onClose?: never });

type Props = SmallBadgeProps | MediumLargeBadgeProps;

export const Badge: React.FC<Props> = ({ status, variant, label, size, showClose, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    onClose?.();
    setIsVisible(false);
  };

  const baseProps = { status, variant, label };

  if (size === 'sm') {
    return <BadgePresentation {...baseProps} size={size} />;
  }

  return (
    <BadgePresentation
      {...baseProps}
      size={size}
      {...(showClose ? { showClose: true, onClickClose: handleClose } : { showClose: false })}
    />
  );
};
